import React from "react";

export default function TabIntro({ icon, title, description, className = "" }) {
  return (
    <header className={`mb-6 animate-ds-fade-in ${className}`}>
      <div className="mb-1 flex items-center gap-2">
        {icon && <span className="text-2xl" aria-hidden>{icon}</span>}
        <h1 className="font-display text-hero font-bold tracking-tight text-fg">{title}</h1>
      </div>
      <p className="max-w-3xl text-sm leading-relaxed text-fg-secondary md:text-base">{description}</p>
    </header>
  );
}
